import { messagesApi } from "@/fetch/api/messages"
import { createContext, ReactNode, useContext, useState } from "react"
import { useEffectOnce } from "react-use"
import { MessagePerRecipientWithAttahcments } from "src/types"

const MessagesContext = createContext<
  | {
      messages: MessagePerRecipientWithAttahcments[]
      updateMessages: () => Promise<void>
      unread: number
    }
  | undefined
>(undefined)

export const MessagesProvider = ({ children }: { children: ReactNode }) => {
  const [messages, setMessages] = useState<
    MessagePerRecipientWithAttahcments[]
  >([])

  async function fetchMessages() {
    const res = await messagesApi.getMyMessages()
    setMessages(res)
  }
  useEffectOnce(() => {
    fetchMessages()
  })

  const unread = messages.filter((x) => !x.readAt).length

  const value = {
    messages,
    updateMessages: fetchMessages,
    unread,
  }

  return (
    <MessagesContext.Provider value={value}>
      {children}
    </MessagesContext.Provider>
  )
}

// 3️⃣ Custom hook for using the context easily
export const useMessages = () => {
  const context = useContext(MessagesContext)
  if (!context) {
    throw new Error("useCounter must be used within a MessagesProvider")
  }
  return context
}
